
export default function routes($stateProvider) {
	$stateProvider
		.state('storesPage', {
			url: '/stores/:zoneId',
			template: require('./stores.html'),
			resolve: {
				loggedIn: ['User', function (User) {
					return User.requireLogin();
				}],
				zones: ['Zone', function (Zone) {
					return Zone.all();
				}]
			},
			controller: 'StoresController',
			controllerAs: 'stores'
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/stores/stores.routes.js